export default __webpack_public_path__ + "static/media/ddsu5168_4p.9dd35fc0.png";